import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BenjiKIVSpine} from "../../components/BenjiKIVSpine";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVStatics} from "../../BenjiKIVStatics";
import {gsap} from "gsap";
import {SpineUtils} from "../../utils/SpineUtils";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";

/**
 * Created by Jerker Nord on 2023-01-24.
 */

export class BenjiKIVSymbolSplitView extends PIXI.Container implements StageLayer {

    private static ANIMATION_NAME:string = "X_Split";

    private splitAnimations:BenjiKIVSpine[][];

    constructor() {
        super();
        this.name = "BenjiKIVSymbolSplitView";

        this.init();
    }

    private init():void {
        this.position = BenjiKIVStatics.MAIN_REELS_VIEW_POSITION;
        this.position.y += BenjiKIVStatics.symbolHeight * 2;

        this.splitAnimations = [];
        let tempAnimation:BenjiKIVSpine;
        for(let i:number = 0; i < 5; i++) {
            let reelAnimations:BenjiKIVSpine[] = [];
            for(let j:number = 0; j < 3; j++) {
                tempAnimation = BenjiKIV.splitSymbolSpinesPool.getAnimation();
                tempAnimation.position.x = BenjiKIVStatics.reelPositions[i].x;
                tempAnimation.position.y = BenjiKIVStatics.symbolHeight * j;
                tempAnimation.visible = false;
                this.addChild(tempAnimation)
                reelAnimations.push(tempAnimation);
            }
            this.splitAnimations.push(reelAnimations);
        }
    }

    public getSplitSymbolAnimation(reel:number, row:number):gsap.core.Timeline {
        row -= 3;
        const splitSymbolTL:gsap.core.Timeline = gsap.timeline();
        splitSymbolTL.add(() => {this.splitAnimations[reel][row].visible = true});
        splitSymbolTL.add(() => {SpineUtils.resetSpineAnimation(this.splitAnimations[reel][row])});
        splitSymbolTL.add(new SpineTween(this.splitAnimations[reel][row], 0, BenjiKIVSymbolSplitView.ANIMATION_NAME));
        splitSymbolTL.add(() => {this.splitAnimations[reel][row].visible = false});
        return splitSymbolTL;
    }
}